import { render, staticRenderFns } from "./project_view.vue?vue&type=template&id=7b9ed970&scoped=true&"
import script from "./project_view.vue?vue&type=script&lang=js&"
export * from "./project_view.vue?vue&type=script&lang=js&"
import style0 from "./project_view.vue?vue&type=style&index=0&id=7b9ed970&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9ed970",
  null
  
)

export default component.exports